import i18n from '../../../i18n'
/**
 * Catalogue des surcouches Protomaps (source-layer roads / water).
 */
export type MapLayerCatalogGroup = 'sentiers' | 'chemins' | 'routes' | 'eau'

export interface MapLayerCatalogEntry {
  layerId: string
  label: string
  group: MapLayerCatalogGroup
  sourceLayer?: string
  matchKind?: string
  matchKindDetail?: string
  defaultEnabled: boolean
  defaultThicken?: boolean
  defaultSolid: boolean
  defaultLineColor?: string
}

export const MAP_LAYER_GROUP_LABELS: Record<string, string> = {
  get sentiers() { return i18n.t('map:mapLayerCatalog.groupe_sentiers') },
  get chemins() { return i18n.t('map:mapLayerCatalog.groupe_chemins') },
  get routes() { return i18n.t('map:mapLayerCatalog.groupe_routes') },
  get eau() { return i18n.t('map:mapLayerCatalog.groupe_eau') },
}

export const OUTDOOR_V4_LAYER_CATALOG: MapLayerCatalogEntry[] = [
  {
    layerId: 'pm_path',
    get label() { return i18n.t('map:mapLayerCatalog.sentier_chemin_path') },
    group: 'sentiers',
    sourceLayer: 'roads',
    matchKind: 'path',
    matchKindDetail: 'path',
    defaultEnabled: true,
    defaultThicken: true,
    defaultSolid: true,
    defaultLineColor: '#b45309',
  },
  {
    layerId: 'pm_footway',
    get label() { return i18n.t('map:mapLayerCatalog.chemin_pieton_footway') },
    group: 'sentiers',
    sourceLayer: 'roads',
    matchKind: 'path',
    matchKindDetail: 'footway',
    defaultEnabled: true,
    defaultThicken: true,
    defaultSolid: true,
    defaultLineColor: '#ca8a04',
  },
  {
    layerId: 'pm_track',
    get label() { return i18n.t('map:mapLayerCatalog.piste_forestiere_track') },
    group: 'sentiers',
    sourceLayer: 'roads',
    matchKind: 'path',
    matchKindDetail: 'track',
    defaultEnabled: true,
    defaultThicken: true,
    defaultSolid: true,
    defaultLineColor: '#92400e',
  },
  {
    layerId: 'pm_bridleway',
    get label() { return i18n.t('map:mapLayerCatalog.chemin_equestre_bridleway') },
    group: 'chemins',
    sourceLayer: 'roads',
    matchKind: 'path',
    matchKindDetail: 'bridleway',
    defaultEnabled: false,
    defaultThicken: true,
    defaultSolid: true,
  },
  {
    layerId: 'pm_steps',
    get label() { return i18n.t('map:mapLayerCatalog.escaliers_steps') },
    group: 'chemins',
    sourceLayer: 'roads',
    matchKind: 'path',
    matchKindDetail: 'steps',
    defaultEnabled: true,
    defaultThicken: true,
    defaultSolid: false,
  },
  {
    layerId: 'pm_pedestrian',
    get label() { return i18n.t('map:mapLayerCatalog.zone_pietonne_pedestrian') },
    group: 'chemins',
    sourceLayer: 'roads',
    matchKind: 'path',
    matchKindDetail: 'pedestrian',
    defaultEnabled: false,
    defaultThicken: true,
    defaultSolid: true,
  },
]

export const CATALOG_LAYER_IDS = new Set(OUTDOOR_V4_LAYER_CATALOG.map((e) => e.layerId))
